import { SsoProviderType } from '@dadohr/shared/domainTypes/sso';
import styled from '@emotion/styled';
import { Card, Typography } from '@material-ui/core';
import { capitalize } from 'lodash';
import { useUnsafeTranslation } from '../../../../i18next';
import { LightMdToJsx } from '../../../../services/formatter';

const Container = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  minHeight: '100%',

  textAlign: 'center',
  gap: p.theme.spacing(),

  backgroundColor: p.theme.custom.colors.gray.w100
}));

const DadoLogoContainer = styled('div')((p) => ({
  marginBottom: p.theme.spacing(1)
}));

const HeadlineContainer = styled('div')((p) => ({
  marginBottom: p.theme.spacing(3)
}));

export const WrongSsoUserInSession = ({
  email,
  provider
}: {
  email: string;
  provider: SsoProviderType;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <Container>
      <DadoLogoContainer>
        <img src={'/images/dado-logo/dado-logo.svg'} height={48} alt="Dado" />
      </DadoLogoContainer>
      <Card style={{ maxWidth: 600 }}>
        <HeadlineContainer>
          <Typography component="h3" variant="h3">
            {t('You are not authorized to access this page.')}
          </Typography>
        </HeadlineContainer>
        <LightMdToJsx component="p">
          {t(
            'You are logged in as **{{ email }}**. Please log in via {{ provider }} using the appropriate account and try to refresh this page.',
            {
              email,
              provider: capitalize(provider.toLowerCase())
            }
          )}
        </LightMdToJsx>
      </Card>
    </Container>
  );
};
